import { getRowColFromIndex } from "./drawing.js";

export function isSolved(shuffledIds, titleIds) {
  for (let i = 0; i < shuffledIds.length; i++) {
    if (shuffledIds[i] == -1) continue;
    if (shuffledIds[i] != titleIds[i]) return false;
  }
  return true;
}
export function drawLastTitle(titleIds, titleImgs, ctx, board, shuffledIds) {
  let blank = findBlankIndex(shuffledIds);
  let coords = getRowColFromIndex(blank, board.rowCols);
  let x = coords.x;
  let y = coords.y;
  let imgUrl = titleImgs[titleIds[blank]];
  const imgObj = new Image();
  imgObj.onload = function () {
    ctx.drawImage(
      this,
      0,
      0,
      this.width,
      this.height,
      x * board.titleWidth,
      y * board.titleHeight,
      board.titleWidth,
      board.titleHeight
    );
  };
  imgObj.src = imgUrl;
}
export function findBlankIndex(shuffledIds) {
  for (let i = 0; i < shuffledIds.length; i++) {
    if (shuffledIds[i] == -1) return i;
  }
}
